module.exports = __webpack_public_path__ + "static/img/ys.ab89afe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/转录组测序/ys.png
// module id = jhq0
// module chunks = 16